(() => {
    let mobileSearchBtn = document.querySelector('#mobileSearchButton');
    let searchForm = document.querySelector('#searchForm');
    let header = document.getElementsByTagName('header')[0];

    const initStateReady = () => {
        if (mobileSearchBtn && searchForm && header) {
            mobileSearchBtn.addEventListener('click', toogleSearch);
        }
    };

    const toogleSearch = () => {
        searchForm.classList.toggle('show');
        header.classList.toggle('show-search');
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        initStateReady();
    });
})();
